import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';

import { BrandAdminHeaderComponent } from './components/brand-admin-header/brand-admin-header.component';
import { ChooseBrandComponent } from './components/choose-brand/choose-brand.component';
import { DynamicEvFieldComponent } from '../components/dynamic-ev-field/dynamic-ev-field.component';
import { DynamicAccountFieldsComponent } from '../components/dynamic-account-fields/dynamic-account-fields.component';
import { PhoneMaskDirective } from '../directives/phone-mask.directive';

@NgModule({
  declarations: [
    BrandAdminHeaderComponent,
    ChooseBrandComponent,
    DynamicEvFieldComponent,
    DynamicAccountFieldsComponent,
    PhoneMaskDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    ConfirmDialogModule,
    MessageModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    ConfirmDialogModule,
    MessageModule,
    BrandAdminHeaderComponent,
    ChooseBrandComponent,
    DynamicEvFieldComponent,
    DynamicAccountFieldsComponent,
    PhoneMaskDirective
  ]
})
export class SharedModule { }
